import React from "react";

const TableBody = ({ children }: { children: React.ReactNode }) => {
  return <tbody className="">{children}</tbody>;
};

export default TableBody;
